import React from "react";
import useStore from "../../../store/store";

const GlobalAlert = () => {
  const alertData = useStore((state) => state.alertData);
  const hideAlert = useStore((state) => state.hideAlert);

  if (!alertData.show) return null;

  const getAlertClass = () => {
    switch (alertData.type) {
      case "success":
        return "alert-secondary";
      case "error":
        return "alert-danger";
      case "warning":
        return "alert-warning";
      case "info":
        return "alert-info";
      default:
        return "alert-secondary";
    }
  };

  const getIcon = () => {
    switch (alertData.type) {
      case "success":
        return "feather-check-circle";
      case "error":
        return "feather-x-circle";
      case "warning":
        return "feather-alert-triangle";
      case "info":
        return "feather-info";
      default:
        return "feather-check-circle";
    }
  };

  const getTitle = () => {
    switch (alertData.type) {
      case "success":
        return "Confirmed";
      case "error":
        return "Error";
      case "warning":
        return "Warning";
      case "info":
        return "Information";
      default:
        return "Confirmed";
    }
  };

  return (
    <div
      className="position-fixed top-0 start-50 translate-middle-x mt-3"
      style={{ zIndex: 9999 }}
    >
      <div
        className="card bg-white border-0 shadow-lg"
        style={{ minWidth: "400px" }}
      >
        <div className={`alert custom-alert1 ${getAlertClass()}`}>
          <button
            type="button"
            className="btn-close ms-auto"
            aria-label="Close"
            onClick={hideAlert}
          >
            <i className="fas fa-xmark" />
          </button>
          <div className="text-center px-5 pb-0">
            <div className="custom-alert-icon">
              <i className={`${getIcon()} flex-shrink-0`} />
            </div>
            <h5>{getTitle()}</h5>
            <p className="">
              {alertData.message ||
                "This alert is created to show a confirmation message."}
            </p>
            <div className="">
              <button
                className="btn btn-sm btn-secondary m-1"
                onClick={hideAlert}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalAlert;
